export default {
  title: 'ビデオプロジェクト',
  titleAndImage: '動画＆画像プロジェクト',
  desc: 'オンライン動画と画像制作ツール：クリックで画像作成、ミックス編集、AI ボイスオーバー、背景削除、動画の多言語と多サイズ対応などの機能。',
  addProject: {
    add: '新しいプロジェクト',
    addBlank: '新しいビデオプロジェクト-動画編集',
    addAI: '新しいビデオプロジェクト-AI動画作成',
    popover: {
      addBlank: '動画エディタ',
      addTemplate: 'レイアウトテンプレート',
      addAI: 'AI動画作成',
    },
    success: 'プロジェクトの作成に成功しました',
  },
  tab: {
    normal: '動画エディタ',
    ai: 'AI動画エディタ',
    aiBanner: 'AI画像生成',
  },
  select: {
    name: 'プロジェクト名',
    projectName: '製品名',
  },
  drop: {
    addProject: {
      title: '新しい動画プロジェクト',
    },
    text: 'プロジェクト名',
    language: '言語',
    cancal: 'キャンセル',
    sure: '確認',
    copyProject: {
      title: 'プロジェクトの複製',
    },
    delProject: {
      title: 'このプロジェクトを削除しますか？',
      text: '削除後は元に戻せません、削除してもよろしいですか？',
      demoText:
        'このプロジェクトはデモプロジェクトです。削除後に復元が必要な場合は、担当者ご連絡ください。削除してもよろしいですか？',
    },
  },
  empty: {
    title1: '検索結果なし',
    desc1:
      '条件に合致する結果が見つかりませんでした。異なる検索条件をお試しください。',
    title2: 'データがありません。',
    desc2: 'まだ動画プロジェクトがありません。今すぐ制作を始めましょう！',
  },
  table: {
    name: 'プロジェクト名およびID',
    operation: {
      title: '操作',
      lock: 'ロック',
      lockTips:
        'ロック後、このプロジェクトは削除および保存できなくなります。ロックしますか？',
      lockSuccessTips: 'ロックしました',
      unlock: 'ロック解除',
      unlockText: 'ロック解除',
      unlockTips:
        'アンロック後、このプロジェクトは削除および保存できるようになります。ロックを解除しますか？',
      unlockSuccessTips: 'ロックを解除しました',
      lockText: 'ロック',
      copy: 'コピー',
      edit: '編集',
      prejectInfo: '詳細を見る',
      delete: '削除',
    },
    projectName: '製品名',
    language: '言語',
    time: '期間',
    exportNum: 'エクスポート成功回数',
    updateTime: '更新日',
    createTime: '作成日',
    projectLocked: 'このプロジェクトはロックされています。',
    projectLockedDeleteTip:
      'このプロジェクトはロックされており、削除できません。',
    projectLockedEditTip:
      'このプロジェクトはロックされており、編集できません。',
    groupTotal: 'バッチ組み合わせ数',
    exportTotal: 'エクスポートタスク数',
    exportCountTips: 'エクスポート成功数 / エクスポート作品総数',
  },
  projectDrop: {
    tabs1: 'プロジェクトの詳細',
    tabs2: 'エクスポート履歴',
    title1: '基本情報',
    info: {
      name: 'プロジェクト名',
      id: 'プロジェクトID',
      time: 'プロジェクト期間',
      exportNum: 'エクスポート回数',
      founder: '作成者',
      updater: '最終更新者',
      updateTime: '更新日',
      productName: '製品名',
      templateName: 'テンプレートの名前',
      ratios: 'プロジェクトサイズ',
      mainRatio: 'メインクリエイティブサイズ',
      languages: 'プロジェクト言語',
    },
    title2: '関連するプロモーション製品',
    associate: {
      title: 'データがありません',
      desc: 'プロジェクトと既存の製品を関連付けましょう！',
      add: 'プロモーション製品を関連付け',
      select: 'プロモーション製品を選択',
      new: '新しいプロモーション製品を追加',
      placeholder: 'キーワードで検索して選択してください',
      info: {
        package: 'パッケージ名',
        desc: '説明',
      },
    },
    subtitle: {
      editAndExport: '編集＆エクスポート情報',
    },
  },
  filter: {
    fabrication: {
      placeholder: '制作方法',
      normal: '通常制作',
      batch: 'バッチ制作',
      simple: 'クイックリプレース',
    },
  },
  rulesTips: 'プロジェクト名は必須です',
  titleTips: '作品名は必須です',
}
